
import CryptoJS from 'crypto-js';
import { ElMessageBox } from 'element-plus'
import router from '@/router/index'

// CryptoJS加密
function generateSignature(params) {
  let secretKey = 'BwkLGbyfTiyij3QG9si5FCozqeC4FaK5hDvPsIANpkM02zjBn1z3+svtISsDbPHV0d4KxCKzzySAwLdQA3PuDA=='
  let sortedKeys = Object.keys(params)
  let paramStr = '';
  sortedKeys.forEach((key) => {
    paramStr += `${key}=${params[key]}`;
  });
  let signStr = paramStr + secretKey;
  let hash = CryptoJS.SHA512(signStr);
  let hexString = hash.toString(CryptoJS.enc.Hex);
  return hexString;
}
// 排序
function dataSort(obj) {
  let sortedKeys = Object.keys(obj).sort();
  let sortedObj = {};
  sortedKeys.forEach(key => {
    if (obj[key] !== null && obj[key] !== undefined) {
      sortedObj[key] = obj[key];
    }
  });
  return sortedObj
}
// AES解密
function aesDecrypt(encryptedText) {
  if (!encryptedText) {
    return encryptedText
  }
  let key = `Bk0e+K9Ddbr5hc1N3Yhg+g==`
  try {
    const decodedKey = CryptoJS.enc.Base64.parse(key); // Base64 解码密钥
    const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText); // Base64 解码加密数据
    const decrypted = CryptoJS.AES.decrypt( // 解密
      { ciphertext: encryptedBytes }, // 加密数据
      decodedKey, // 密钥
      {
        mode: CryptoJS.mode.ECB, // 加密模式（根据 Java 代码的 TRANSFORMATION 设置）
        padding: CryptoJS.pad.Pkcs7 // 填充模式
      }
    );
    let encryResult = decrypted.toString(CryptoJS.enc.Utf8)// 将解密结果转换为 UTF-8 字符串
    return encryResult ? decrypted.toString(CryptoJS.enc.Utf8) : encryptedText
  } catch (error) {
    return encryptedText
  }
}

// 请求结果错误处理
function responseHandleError(error) {
  if (error.response) {
    switch (error.response.status) {
      case 406:
        ElMessageBox.confirm('登录信息已失效，请重新登录')
          .then(() => {
            router.push('/login')
            history.go(0)
          })
          .catch(() => {
            router.push('/login')
            history.go(0)
          })
        break
      case 401:
        ElMessageBox.confirm('登录信息已失效，请重新登录')
          .then(() => {
            router.push('/login')
            history.go(0)
          })
          .catch(() => {
            router.push('/login')
            history.go(0)
          })
        break
    }
  }
}
// 判断是否为JSON
function isJSON(str) {
  try {
    JSON.parse(str); // 尝试解析字符串
    return true; // 如果解析成功，说明是 JSON
  } catch (e) {
    return false; // 如果解析失败，说明不是 JSON
  }
}
// 处理方法
function handlingMethod(data, encryList) {
  //数据类型为数组
  if (Array.isArray(data)) {
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < encryList.length; j++) {
        if (data[i][encryList[j]]) {
          if (encryList[j] === 'extend') {
            if (data[i][encryList[j]].value && Object.keys(data[i][encryList[j]]).length === 1) {
              if (isJSON(aesDecrypt(data[i][encryList[j]].value))) {
                data[i][encryList[j]] = JSON.parse(aesDecrypt(data[i][encryList[j]].value))
              }

            }
          } else {
            data[i][encryList[j]] = aesDecrypt(data[i][encryList[j]])
          }
        }
      }
    }
  }
  //数据类型为纯对象，非数组、非函数、非其他内置类型
  if (data !== null && typeof data === "object" && data.constructor === Object) {
    for (let j = 0; j < encryList.length; j++) {
      if (data[encryList[j]]) {
        if (encryList[j] === 'extend') {
          if (data[encryList[j]].value && Object.keys(data[encryList[j]]).length === 1) {
            if (isJSON(aesDecrypt(data[encryList[j]].value))) {
              data[encryList[j]] = JSON.parse(aesDecrypt(data[encryList[j]].value))
            }

          }
        } else {
          data[encryList[j]] = aesDecrypt(data[encryList[j]])
        }
      }
    }
  }
  // console.log(data)
  return data
}
// 请求结果处理
function responseHandle(response) {
  if (response.status === 200) {
    if (response.data) {
      let url = response.config.url
      let questionMarkPosition = url.indexOf("?");
      if (questionMarkPosition !== -1) {
        url = url.substring(0, questionMarkPosition);
      }
      // console.log(url)
      if (url === '/platform-member/rep/page') { // 代表委员page
        let encryList = ['phone', 'birthday', 'workUnit', 'incumbentPost', 'peopleid', 'representative', 'extend']
        response.data.resultValue = handlingMethod(response.data.resultValue, encryList)
      }
      if (url === '/platform-member/rep/search') {  // 代表委员search
        let encryList = ['phone', 'birthday', 'workUnit', 'incumbentPost', 'peopleid', 'representative', 'extend']
        response.data = handlingMethod(response.data, encryList)
      }
      if (url === '/sys/article/v1/page') {
        let encryList = ['extend']
        response.data.content = handlingMethod(response.data.content, encryList)
      }
      // 人大建议，党代表建议，政协提案
      if (url === '/suggestion-congress/suggestion/findByName'
        || url === '/suggestion-party/suggestion/findByName'
        || url === '/suggestion-cppcc/suggestion/findByName'
      ) {
        let encryList = ['superviseRepPhone', 'contactsPhone', 'replyPhone', 'extend']
        response.data.resultValue = handlingMethod(response.data.resultValue, encryList)
      }
      if (
        url === '/suggestion-cppcc/suggestion/examine/v1/setNumber'
      ) {
        let encryList = ['superviseRepPhone', 'contactsPhone', 'replyPhone', 'extend']
        response.data = handlingMethod(response.data, encryList)
      }
    }
  }
  return response
}


export { responseHandle, generateSignature, dataSort, responseHandleError, aesDecrypt }